class CartCount extends window.BAO.CustomElement() {
  static get requiredExternalEls () {
    return ['banner-cart']
  }

  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return

    if (!('push-cart-count' in state?.sections)) return

    const count = Number(this.getCount(state.sections['push-cart-count']))

    this.textContent = this.getCount(state.sections['push-cart-count'])
    this.setAttribute('aria-hidden', String(count === 0))

    this.externalEls['banner-cart'].elements.forEach(
      el => (el.dataset.active = String(count > 0)),
    )

    this.externalEls['sis-footer'].elements.forEach(el =>
      el.setAttribute('aria-hidden', String(count === 0)),
    )
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
